const TUTORIAL_COMPLETED_STORAGE_KEY = "hasCompletedTutorial";

export function readClientTutorialCompleted(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(TUTORIAL_COMPLETED_STORAGE_KEY) === "1";
}

export function writeClientTutorialCompleted(): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(TUTORIAL_COMPLETED_STORAGE_KEY, "1");
}
